export type PurposeCodeOption = { label: string; value: string };

export const mapPurposeCodes = (response: any): PurposeCodeOption[] => {
  const items = Array.isArray(response) ? response : response?.data;
  if (!Array.isArray(items)) return [];

  return items
    .map((item: any) => {
      const value = item?.code ?? item?.purposeCode;
      const label = item?.description ?? item?.name ?? item?.purpose ?? value;
      return value ? { label: String(label), value: String(value) } : null;
    })
    .filter((option): option is PurposeCodeOption => option !== null);
};

export const CHINESE_NATIONAL_ID_REGEX = /^[A-Za-z0-9]{18}$/;

export const CHINESE_NATIONAL_ID_RULES = (requiredMessage = "Chinese National ID is required") => ({
  required: requiredMessage,
  pattern: {
    value: CHINESE_NATIONAL_ID_REGEX,
    message: "Chinese National ID must be an 18-character alphanumeric string",
  },
});

export const getChinaTransactionLimit = (
  paymentMethod?: string,
  paymentClassification?: string,
  purpose?: string
): { maxLimit: number; routeName: string } => {
  if (paymentMethod === "alipay") {
    return { maxLimit: 50000, routeName: "Alipay" };
  }
  if (paymentMethod === "unionpay") {
    return { maxLimit: 50000, routeName: "UnionPay" };
  }
  if (paymentMethod === "bank_account") {
    const isGoods =
      paymentClassification === "Goods" || purpose === "Payments for goods";
    if (isGoods) {
      return { maxLimit: 500000, routeName: "Physical Goods" };
    }
    return { maxLimit: 1000000, routeName: "Bank Account" };
  }
  return { maxLimit: 1000000, routeName: "CNY payout" };
};

